// to add expand/collapse in about delivery
        document.addEventListener("DOMContentLoaded", function() {
            if (window.innerWidth <= 768) {
                document.querySelectorAll(".info-box h3").forEach(function(header) {
                    header.addEventListener("click", function() {
                        this.parentElement.classList.toggle("active");
                    });
                });
            }
        });


// to hide feature collection if empty
  document.addEventListener("DOMContentLoaded", function() {
    // --- Product List 1 (Original Check) ---
    var productList = document.querySelector('product-list.product-list');
    var anotherDiv = document.querySelector('.section-stack');

    function checkProductList() {
      // Check if anotherDiv exists before trying to access its style
      if (anotherDiv) {
        if (!productList || (productList.children.length === 0)) {
          anotherDiv.style.display = 'none';
        } else {
          anotherDiv.style.display = '';
        }
      }
    }

    checkProductList(); // Initial check

    // Observe for changes in the product list, but only if the productList element exists
    if (productList) {
      var observer = new MutationObserver(checkProductList);
      observer.observe(productList, { childList: true });
    }

    // --- Product List 2 (The Error Fix) ---
    var productList2 = document.querySelector('scroll-carousel#scroll-area-template--27139030581622__featured_collection_qn3NyX product-list.product-list');
    var anotherDivTwo = document.querySelector('section#shopify-section-template--27139030581622__featured_collection_qn3NyX .section-stack');
    var parentpaddingremove = document.querySelector('section#shopify-section-template--27139030581622__featured_collection_qn3NyX .section.section-blends.section-full');

    function checkProductList2() {
      // Check if both elements we want to style exist (anotherDivTwo and parentpaddingremove)
      if (anotherDivTwo && parentpaddingremove) {
        if (!productList2 || (productList2.children.length === 0)) {
          anotherDivTwo.style.display = 'none';
          parentpaddingremove.style.padding = '0'; // Safe now because parentpaddingremove is checked
        } else {
          anotherDivTwo.style.display = '';
        }
      }
    }

    checkProductList2(); // Initial check

    // Observe for changes in the product list, but only if the productList2 element exists
    if (productList2) {
      var observer2 = new MutationObserver(checkProductList2);
      observer2.observe(productList2, { childList: true });
    }

    // --- Product List 3 (Fix Applied Here Too) ---
    var productList3 = document.querySelector('scroll-carousel#scroll-area-template--27139030581622__featured_collection_UMVfDD product-list.product-list');
    var anotherDivThree = document.querySelector('section#shopify-section-template--27139030581622__featured_collection_UMVfDD .section-stack');
    var parentpaddingremove3 = document.querySelector('section#shopify-section-template--27139030581622__featured_collection_UMVfDD .section.section-blends.section-full'); // Renamed variable for clarity

    function checkProductList3() {
      // Check if both elements we want to style exist (anotherDivThree and parentpaddingremove3)
      if (anotherDivThree && parentpaddingremove3) {
        if (!productList3 || (productList3.children.length === 0)) {
          anotherDivThree.style.display = 'none';
          parentpaddingremove3.style.padding = '0'; // Safe now
        } else {
          anotherDivThree.style.display = '';
        }
      }
    }

    checkProductList3(); // Initial check

    // Observe for changes in the product list, but only if the productList3 element exists
    if (productList3) {
      var observer3 = new MutationObserver(checkProductList3);
      observer3.observe(productList3, { childList: true });
    }

  });


// --- Early removal of video in mobile and move it to bottom ---
(function() {
  var observer = new MutationObserver(function(mutations, obs) {
    var el = document.querySelector('.videoCol-gallery');
    if (el) {
      el.style.display = 'none'; // hide immediately just in case
      el.remove();               // yank it from the DOM
      window._videoColEl = el;   // store globally to reinsert later
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// --- Reinsert in correct location ---
document.addEventListener('DOMContentLoaded', function() {
  function placeVideoCol() {
    if (!window._videoColEl) return;

    var safeSticky = document.querySelector('safe-sticky.product-info');
    var productGallery = document.querySelector('product-gallery');

    if (window.innerWidth <= 768 && safeSticky) {
      if (!safeSticky.contains(window._videoColEl)) {
        safeSticky.insertBefore(window._videoColEl, safeSticky.lastChild);
      }
    } else if (productGallery) {
      if (!productGallery.contains(window._videoColEl)) {
        productGallery.appendChild(window._videoColEl);
      }
    }
    window._videoColEl.style.display = ''; // make it visible
  }

  // First placement
  placeVideoCol();

  // Update on resize
  window.addEventListener('resize', placeVideoCol);
});